import * as React from "react";
import { DataGrid } from "@mui/x-data-grid";
import gridLabels from "../Labels/GridLabels";
import GRAPHS_COLUMNS from "./GraphsTableColumn";
import { Box, Stack } from "@mui/system";
import RowButtonIcon from "../UI/RowButtonIcon";
import EditIcon from "@mui/icons-material/Edit";
import ButtonAdd from "../UI/ButtonAdd";
import BoxRowButtonsIcon from "../UI/BoxRowButtonsIcon";
import DialogDelete from "../UI/DialogDelete";
import SearchInput from "../UI/SearchInput";
import { DeleteOutline } from "@mui/icons-material";
import { useNavigate, useLocation } from "react-router-dom";
import { Add } from "@mui/icons-material";
import FolderOpenIcon from "@mui/icons-material/FolderOpen";
import RowButtonLabel from "../UI/RowButtonLabel";
import StartingPageContent from "../StartingPage/StartingPageContent";
import useGraphStore from "../../store/zustandStore/graphZs";
import ImageViewModal from "./ImageViewModal";
import debounce from "../../utils/debounce";
import { Button, InputLabel, TextField } from "@mui/material";
// import ChapterModalEditor from "./ChapterModalEditor";

const GraphTable = () => {
  const navigate = useNavigate();

  const onBackNavigation = () => {
    navigate(-1);
  };
  const location = useLocation();

  //   const { reportId, reportTitle, year } = location.state;

  const {
    graphsZs,
    totalPages,
    totalElements,
    size,
    currentPage,
    searchValueCurrent,
    setCurrentPage,
    setSearchValueCurrent,
    fetchGraphsZs,
    deleteGraphZs,
    setYear,
    year,
    setYearAndFetch,
  } = useGraphStore();

  const [open, setOpen] = React.useState(false);
  const handleClose = () => setOpen(false);
  const [stateDialogDelete, setStateDialogDelete] = React.useState(false);
  const [isStatusNew, setIsStatusNew] = React.useState(false);
  const [isOpenImageViewModal, setIsOpenImageViewModal] = React.useState(false);
  const [graph, setGraph] = React.useState({});
  const [dataColumns, setDataColumns] = React.useState(GRAPHS_COLUMNS);
  const [yearTemp, setYearTemp] = React.useState(year);
  //   const [page, setPage] = React.useState(currentPage);
  const searchState = React.useRef("");

  const initialGraph = {
    id: "",
    title: "",
    name: "",
  };

  const handleChangePage = (event, newPage) => {
    // setPage(event);
    // setCurrentPage(i + 1);
    setCurrentPage(event);
  };

  // 🔁 Memoized debounced handler
  const debouncedSearch = React.useMemo(() => {
    return debounce((value) => {
      setSearchValueCurrent(value);
      fetchGraphsZs();
    }, 1000); // 300ms delay
  }, [setSearchValueCurrent]);

  const searchItems = (e) => {
    debouncedSearch(e.target.value);
    searchState.current.value = e.target.value;
  };

  React.useEffect(() => {
    // setSearchValueCurrent("");
    fetchGraphsZs();
  }, []);

  const [filterModel, setFilterModel] = React.useState({
    items: [
      {
        columnField: "",
        operatorValue: ">",
        value: "",
      },
    ],
  });

  const currentlySelected = (e) => {
    setIsStatusNew(false);
    setIsOpenImageViewModal(true);
    setGraph(e.row);
    setOpen(true);
  };

  const addNew = () => {
    setIsStatusNew(true);
    setGraph(initialGraph);
    setOpen(true);
  };

  const handleCloseDialogDelete = (e) => {
    setStateDialogDelete(false);
  };

  const handleDeleteGraph = (e) => {
    deleteGraphZs(graph);
    setStateDialogDelete(false);
  };

  const openGraphEditorSelected = (e) => {
    // navigate("/reports-print/chapter-editor", {
    //   state: { reportId: reportId, chapter: e.row },
    // });
  };

  const handleYearChange = (event) => {
    const { name, value } = event.target;
    setYearTemp(value);
  };

  function CustomToolbar() {
    return (
      <Box
        sx={{
          width: "100%",
        }}
      >
        <Box
          sx={{
            display: "flex",
            py: "18px",
            px: "9px",
            alignItems: "center",
            bgcolor: "transparent",
          }}
        >
          <Box
            sx={{
              flexGrow: 1,
              textAlign: "center",
              alignItems: "center",
              justifyContent: "center",
              display: "flex",
              flexDirection: "row",
            }}
          >
            <SearchInput
              onChange={searchItems}
              inputRef={searchState}
              defaultValue={searchState.current.value}
            ></SearchInput>
            <Stack
              spacing={2}
              sx={{ mr: "10px", alignItems: "center" }}
              direction="row"
            >
              <TextField
                name="year"
                autoComplete="off"
                id="year"
                type="number"
                variant="outlined"
                sx={{
                  "&.MuiTextField-root .MuiInputBase-root.MuiOutlinedInput-root":
                    {
                      height: "45px",
                      width: "100px",
                      marginLeft: "20px",
                      backgroundColor: "#f6f8fc",
                      textAlign: "center",
                      borderRadius: "5px",
                    },
                  "& .MuiInputBase-input.MuiOutlinedInput-input": {
                    textAlign: "center",
                  },
                }}
                value={yearTemp}
                onChange={handleYearChange}
              />
              <Button
                onClick={() => {
                  setYearAndFetch(yearTemp);
                }}
                sx={{
                  "&.MuiButtonBase-root.MuiButton-root": { width: "100px" },
                }}
              >
                Apliko Vitin
              </Button>
            </Stack>
          </Box>
          {/* <ButtonAdd onClick={addNew} /> */}
        </Box>
      </Box>
    );
  }
  return (
    <StartingPageContent
      pageName={"Grafikët Ekzistues"}
      back
      onClick={onBackNavigation}
    >
      <div style={{ height: 700, width: "100%" }}>
        <DataGrid
          labelRowsPerPage="Artikuj per faqe"
          disableSelectionOnClick
          onRowDoubleClick={
            (params) => currentlySelected({ ...params })
            // setIsOpenImageViewModal(true)
          }
          columns={[
            ...dataColumns,
            {
              headerName: "",
              overflow: "hidden",
              field: "action",
              editable: false,
              flex: 1,
              justifyContent: "flex-end",
              disableClickEventBubbling: true,
              align: "right",
              background: "red",
              headers: false,
              renderHeader: () => {},
              renderCell: (params) => (
                <BoxRowButtonsIcon>
                  {/* <RowButtonLabel
                    onClick={(event) => {
                      openGraphEditorSelected(params);
                    }}
                    startIcon={<FolderOpenIcon />}
                  >
                    Modifiko
                  </RowButtonLabel> */}
                  <RowButtonIcon
                    onClick={(event) => {
                      setIsOpenImageViewModal(true);
                      currentlySelected({ ...params });
                    }}
                  >
                    <EditIcon />
                  </RowButtonIcon>
                  <RowButtonIcon
                    onClick={(event) => {
                      setGraph({ ...params?.row });
                      setStateDialogDelete(true);
                    }}
                  >
                    <DeleteOutline color="error" />
                  </RowButtonIcon>
                </BoxRowButtonsIcon>
              ),
            },
          ]}
          rows={graphsZs ? graphsZs : []}
          density="comfortable"
          editMode="row"
          disableColumnMenu
          localeText={gridLabels}
          componentsProps={{
            pagination: {
              labelRowsPerPage: "Rreshta për Faqe",
              showLastButton: true,
              showFirstButton: true,
            },
          }}
          components={{
            Toolbar: CustomToolbar,
          }}
          // onCellClick={currentlySelected}
          filterModel={filterModel}
          onFilterModelChange={(newFilterModel) =>
            setFilterModel(newFilterModel)
          }
          page={currentPage}
          onPageChange={handleChangePage}
          count={totalPages}
          rowCount={totalElements}
          pageSize={size}
          pagination
          paginationMode="server"
        />
        <DialogDelete
          open={stateDialogDelete}
          disagreedelete={handleCloseDialogDelete}
          agreedelete={handleDeleteGraph}
          description="Jeni të sigurt që doni ta fshini këtë Grafik? "
        />
        <ImageViewModal
          fileId={graph?.file?.id}
          title={graph?.title}
          open={isOpenImageViewModal}
          onClose={() => setIsOpenImageViewModal(false)}
        />
        {/* <ChapterModalEditor
          chapterLength={chaptersZs.length}
          open={open}
          reportId={reportId}
          onClose={handleClose}
          formname="Kapitull"
          isstatusnew={isStatusNew ? 1 : 0}
          data={chapter}
        ></ChapterModalEditor> */}
      </div>
    </StartingPageContent>
  );
};

export default GraphTable;
